import type { DbTemplateStatus } from '@domain/schemas/contract.schema';
import {
  DbTemplateStatusSchema,
  NON_PRE_DRAFT_SUBMISSION_STATUSES,
  ResourceState,
} from '@domain/schemas/contract.schema';
import type { QueryFilter } from '@domain/schemas/filters.schema';

export const EXCLUDE_PRE_DRAFTS_FILTERS: QueryFilter[] = [
  { field: 'status', comparator: 'eq', values: NON_PRE_DRAFT_SUBMISSION_STATUSES },
];

/** Template statuses without REVIEW, in schema order. */
export const TEMPLATE_STATUSES: DbTemplateStatus[] = DbTemplateStatusSchema.options.filter(
  (status) => status !== ResourceState.REVIEW,
);
